import { apiFetch } from '@/lib/fetch';

/**
 * Fetching chotto's own auth token. As of now the user is randomly generated in the server and not
 * persisted anywhere.
 */
export async function getChottoAuthToken() {
  const response = await apiFetch("/auth/user/guest-login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP error! Status: ${response.status}, Body: ${errorText}`);
  }

  const { token } = await response.json();
  return token;
}
